export const pageControlCommonStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    container: {
        position: 'relative',
        display: 'flex',
        align_items: 'center',
        justify_content: 'center',
        width: '100%',
        ...STATE_TOKENS.container,
    },
    dotsContainer: {
        display: 'flex',
        align_items: 'center',
        justify_content: 'center',
        gap: FOUNDATIONS.spacing_150,
        ...STATE_TOKENS.dotsContainer,
    },
    leftButtonControl: {
        position: 'absolute',
        width: '50%',
        height: '100%',
        min_width: FOUNDATIONS.size_300,
        min_height: FOUNDATIONS.size_300,
        cursor: 'pointer',
        left: '0',
        disabled: {
            cursor: 'default',
        },
        ...STATE_TOKENS.leftButtonControl,
    },
    rightButtonControl: {
        position: 'absolute',
        width: '50%',
        height: '100%',
        min_width: FOUNDATIONS.size_300,
        min_height: FOUNDATIONS.size_300,
        cursor: 'pointer',
        right: '0',
        disabled: {
            cursor: 'default',
        },
        ...STATE_TOKENS.rightButtonControl,
    },
});
export const pageControlCommonStateStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    position: 'relative',
    border_radius: FOUNDATIONS.radius_1000,
    height: FOUNDATIONS.size_100,
    width: FOUNDATIONS.size_200,
    flex: 'none',
    ...STATE_TOKENS,
});
export const arrowControlCommonStyles = (FOUNDATIONS) => ({
    leftArrowControlContainer: {
        margin_right: FOUNDATIONS.spacing_150,
    },
    rightArrowControlContainer: {
        margin_left: FOUNDATIONS.spacing_150,
    },
});
export const arrowControlActiveStateIconCommonStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    width: FOUNDATIONS.size_300,
    height: FOUNDATIONS.size_300,
    ...STATE_TOKENS,
});
//# sourceMappingURL=commonStyles.js.map